"use client";
import { useEffect } from "react";

export function PageViewInitializer() {
  useEffect(() => {
    const pagePath = window.location.href
    if (typeof window === "undefined") return;

    // Si déjà envoyé, ne rien faire
    if (window.__pageViewSent) return;

    window.__pageViewSent = true;

    // On pousse l'event page_view uniquement une fois au premier montage client
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: pagePath,
      page_title: document.title
    });
  }, []);

  return null;
}
